<template>
	<div class="team-player">
        <img
          :src="getOperatorImage(image)"
          :alt="firstname"
          class="rounded-circle img-fluid img-raised"
        />
        <h4 class="title">{{ firstname }} {{ lastname }}</h4>
        <p class="category text-primary">{{ title }}</p>
        <p class="description text-dark">
          {{ description }}
        </p>
        <router-link 
			to="/aboutus" 
			class="btn btn-primary btn-simple btn-sm"
			title="Learn more about us"
		>
			Learn more
			<i class="fas fa-arrow-right arrow-icon"></i>
		</router-link>
		<div class="social-links">
	        <a
				v-if="facebook"
				:href="facebook" 
				class="btn btn-primary btn-icon btn-round"
	        	title="Follow me on Facebook" 
				target="_blank"
	          ><i class="fab fa-facebook-square"></i
	        ></a>
	        <a
				v-if="instagram"
				:href="instagram" 
				class="btn btn-primary btn-icon btn-round"
	        	title="Follow me on Instagram" 
				target="_blank"
	          ><i class="fab fa-instagram"></i
	        ></a>
	        <a
				v-if="twitter"
				:href="twitter" 
				class="btn btn-primary btn-icon btn-round"
	        	title="Follow me on Twitter" 
				target="_blank"
	          ><i class="fab fa-twitter"></i
	        ></a>
			<a
				v-if="linkedin"
				:href="linkedin" 
				class="btn btn-primary btn-icon btn-round"
	        	title="Follow me on LinkedIn" 
				target="_blank"
	          ><i class="fab fa-linkedin"></i
	        ></a>
		</div>
	</div>
</template>

<script>

export default {
	name: 'OperatorCard',
	data() {
		return {
			
		};
	},
	props: {
		firstname: {
			type: String,
			required: true
		},
		lastname: {
			type: String,
			required: true
		},
		title: {
			type: String,
			required: true
		},
		description: {
			type: String,
		},
		image: {
			type: String,
			required: true,
		},
		facebook: {
			type: String,
			required: false,
		},
		instagram: {
			type: String,
			required: false,
		},
		twitter: {
			type: String,
			required: false,
		},
		linkedin: {
			type: String,
			required: false,
		},
	},
	computed: {
		
	},
	methods: {
		getOperatorImage(filename) {
			return `https://www.beastmodecleanup.com/api/operatorimgs/${filename}`
		},
	}, //end methods
}
</script>

<style>
.learn-more-btn {
  display: inline-flex;
  align-items: center;
  transition: all 0.3s ease;
}

.arrow-icon {
  margin-left: 5px;
  transition: transform 0.3s ease;
}

.learn-more-btn:hover .arrow-icon {
  transform: translateX(5px);
}

.social-links {
  margin-top: 10px;
}
</style>